import { render, staticRenderFns } from "./club_release_event.vue?vue&type=template&id=4e8a2de2&scoped=true&"
import script from "./club_release_event.vue?vue&type=script&lang=js&"
export * from "./club_release_event.vue?vue&type=script&lang=js&"
import style0 from "./club_release_event.vue?vue&type=style&index=0&id=4e8a2de2&lang=scss&scoped=true&"
import style1 from "./club_release_event.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a2de2",
  null
  
)

export default component.exports